import React from "react";
import VisionMission from "./components/VisionMission";
import SubscriptionChoices from "./components/SubscriptionChoices";
import HowItWorks from "./components/HowItWorks";
import ImpactReports from "./components/ImpactEstimateReports";
import WhatsAvailable from "./components/WhatsAvailable";
import ReadyToJoin from "./components/ReadyToJoin";

export const AboutPage: React.FC = () => {
  return (
    <main className="flex-1">
      <VisionMission />
      <SubscriptionChoices />
      <HowItWorks />
      <ImpactReports />
      <SubscriptionChoices detailed={true} />
      <ReadyToJoin />
      <WhatsAvailable />
    </main>
  );
};

AboutPage.displayName = "AboutPage";
